/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Spinner } from "react-bootstrap";

import useHiringManagerPasswordReset from "./useHiringManagerPasswordReset";
import { Carousel } from "antd";

export default (props) => {
  const {
    loading,
    userProfileInfo,
    showPassword1,
    showPassword2,
    formInputsError,
    onShowPasswordClick,
    onResetPasswordClick,
    onInputChange,
    onLoginClick,
  } = useHiringManagerPasswordReset();

  return (
    <div className="common-login">
      <Container className="px-0">
        <div className="row no-gutters">
          <div className="col-lg-6">
            <div className="left-img">
              <div className="login-slider">
                <Carousel autoplay arrows>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-1.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Simplify Your Recruitment Process
                    </h2>
                    <p className="font-weight-medium text-white">
                      Make recruitment easy for businesses of all sizes.
                      Streamline your hiring process, from job posting to
                      candidate management, and discover the best-fit candidates
                      for your team with Jigsaw's innovative platform.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-2.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Rescue Hiring Manger & Candidate From Fate
                    </h2>
                    <p className="font-weight-medium text-white">
                      Don't leave recruitment process of hiring manager and
                      candidate’s career to fate. Take control with Jigsaw's
                      intuitive platform, designed to simplify recruitment and
                      elevate your professional growth. Say goodbye to
                      uncertainty and achieve your goals with Jigsaw.
                    </p>
                  </div>
                  <div className="slider-content">
                    <img
                      src="/assets/images/slider-img-3.svg"
                      alt="slider-img"
                      className="slider-img"
                    />
                    <h2 className="text-white mb-2">
                      Take Control of Your Career with Jigsaw!
                    </h2>
                    <p className="font-weight-medium text-white">
                      Unlock your full potential and achieve your career goals
                      with Jigsaw. Our intuitive platform empowers you with the
                      tools and resources you need to succeed, streamlined job
                      searching and interview preparation. Take control of your
                      future today with Jigsaw.
                    </p>
                  </div>
                </Carousel>
              </div>
            </div>
          </div>
          <div className="col-lg-6 ">
            <div className="form-wrapper py-5 h-100">
              <h1 className="mb-2">Login</h1>
              <p className="h3 text-muted font-weight-normal mb-4">
                Login with the email id you have received inviation
              </p>

              <form action="#" className="mt-4">
                <div className="form-group">
                  <label htmlFor="Password" className="mb-2 font-weight-medium">
                    Invited Email Id
                  </label>
                  <div className="input-with-icon">
                    <input
                      className="form-control"
                      type={"email"}
                      placeholder="Enter your Email Id you have received invitation"
                      onChange={(e) => onInputChange(e.target.value, "email")}
                    />
                  </div>
                  {formInputsError.email && formInputsError.email.length > 0 ? (
                    <span className="text-danger mt-1">
                      {formInputsError.email}
                    </span>
                  ) : null}
                </div>
                <div className="form-group">
                  <label
                    htmlFor="ConfirmPassword"
                    className="mb-2 font-weight-medium"
                  >
                    Enter Password
                  </label>

                  <div className="input-with-icon">
                    <input
                      className="form-control"
                      type={showPassword1 ? "text" : "password"}
                      placeholder="Re-enter your new password"
                      onChange={(e) =>
                        onInputChange(e.target.value, "new_password1")
                      }
                    />
                    <span
                      className="input-icon"
                      onClick={() => onShowPasswordClick("new_password1")}
                    >
                      {showPassword1 ? (
                        <img
                          src="/assets/images/eye-icon-2.png"
                          alt="hide icon"
                        />
                      ) : (
                        <img
                          src="/assets/images/eye-icon.png"
                          alt="view icon"
                        />
                      )}
                    </span>
                  </div>
                  {formInputsError.new_password1 &&
                  formInputsError.new_password1.length > 0 ? (
                    <span className="text-danger mt-1">
                      {formInputsError.new_password1}
                    </span>
                  ) : null}
                </div>
                {formInputsError.formSubmitError &&
                formInputsError.formSubmitError.length > 0 ? (
                  <div>
                    <span className="text-danger mt-1">
                      {formInputsError.formSubmitError}
                    </span>
                  </div>
                ) : null}

                <button
                  className="btn btn-primary btn-block text-center mt-4"
                  onClick={(e) => {
                    e.preventDefault();
                    onResetPasswordClick();
                  }}
                >
                  {loading ? (
                    <Spinner
                      animation="border"
                      variant=""
                      className="text-white"
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
